// src/components/Emissions/EmissionMap.js
import React, { useMemo } from 'react';
import { MapContainer, TileLayer, Polyline, Tooltip } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const EmissionMap = ({ emissionTrail, selectedVehicle }) => {
    const center = useMemo(() => {
        if (emissionTrail.length > 0) {
            return [emissionTrail[0].latitude, emissionTrail[0].longitude];
        }
        return [23.6978, 120.9605]; // 台灣中心點
    }, [emissionTrail]);

    const getColor = (cumulativeEmission) => {
        if (cumulativeEmission < 0.001) return '#00ff00';  // 綠色
        if (cumulativeEmission < 0.01) return '#ffff00';   // 黃色
        if (cumulativeEmission < 0.1) return '#ffa500';    // 橙色
        return '#ff0000';  // 紅色
    };
    const polylines = useMemo(() => {
        const lines = [];
        for (let i = 0; i < emissionTrail.length - 1; i += 1) {
            const start = emissionTrail[i];
            const end = emissionTrail[i + 1];
            const avgEmission = (start.emissionValue + end.emissionValue) / 2;
            lines.push({
                positions: [
                    [start.latitude, start.longitude],
                    [end.latitude, end.longitude]
                ],
                color: getColor(avgEmission),
                emissionValue: avgEmission,
                timestamp: start.timestamp
            });
        }
        return lines;
    }, [emissionTrail]);

    return (
        <MapContainer center={center} zoom={7} style={{ height: '100vh', width: '100%' }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            {polylines.map((line, index) => (
                <Polyline
                    key={index}
                    positions={line.positions}
                    color={line.color}
                    weight={3}
                >
                    <Tooltip>
                        車號: {selectedVehicle}<br />
                        排放量: {line.emissionValue.toFixed(2)} kg CO2<br />
                        時間: {new Date(line.timestamp).toLocaleString()}
                    </Tooltip>
                </Polyline>
            ))}
        </MapContainer>
    );
};

export default EmissionMap;